export default __webpack_public_path__ + "static/media/revenue.7fa78005.png";